export default __webpack_public_path__ + "static/media/impression-etiquettes.b0b385e1.svg";